var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saveFinish"},[_c('div',{staticClass:"mainBox"},[_c('h2',[_vm._v("확인")]),_c('p',[_vm._v("수정이 완료되었습니다.")]),_c('div',{on:{"click":_vm.end}},[_vm._v("확인")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }